export default "__VITE_ASSET__l7AfvS2h__"